import { render, staticRenderFns } from "./HistoryDefault.vue?vue&type=template&id=742703da"
import script from "./HistoryDefault.vue?vue&type=script&lang=js"
export * from "./HistoryDefault.vue?vue&type=script&lang=js"
import style0 from "./HistoryDefault.vue?vue&type=style&index=0&id=742703da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports